import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	assigneeTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	assigneeTooltip: {
		id: 'issue-field-assignee.common.read-view.popover.assignee-tooltip',
		defaultMessage: 'Assignee: {name}',
		description: 'Tooltip of the assignee avatar when hovered over',
	},
});
export default messages;
